export interface TokenResponse {
  idleTimeoutInMinutes: number;
  token: string;
}

export interface TokenContext {
  defaultCultureCode?: string;
  defaultCurrencyCode?: string;
  hasBookingInState?: boolean;
  type?: SessionPermissionType;
}

export enum SessionPermissionType {
  Unknown = 0,
  Customer = 1,
  Anonymous = 2,
  Agent = 3,
}
